var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseList',{attrs:{"color":"primary","title":_vm.title,"section":_vm.$route.meta.section,"headers":_vm.headers,"items":_vm.groups,"loading":_vm.loading,"totalRows":_vm.totalRows},on:{"add":_vm.handleNew,"edit":_vm.handleEdit,"refresh":_vm.getData,"delete":_vm.handleDelete,"search":_vm.handleSearch,"options":_vm.handleOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }